import { createApp } from '@wu/widget-core';
import { meta } from '../constants';
import { FileEmbeds } from './FileEmbeds';

export const createFileEmbed = () => {
  return createApp(meta, FileEmbeds);
};
